import { Button, Col, Row } from 'antd';
import {
  baParticipantLevelNonSelf,
  classParticipantLevel,
  classParticipantType,
  saParticipantLevelNonSelf,
} from '../../../../../App/Enums';

import CIcon from '../../../../../Assets/Components/CIcon';
import { Field } from 'react-final-form';
import { InputTextNumber } from '../../../../../Assets/Components/CInput';
import React from 'react';
import Select from '../../../../../Assets/Components/Select';
import Table from '../../../../../Assets/Components/CTable';
import { convertAgentBALevelNonSelf, convertAgentLevel, convertAgentSALevelNonSelf } from '../../../../../App/Helper';
import { multipleCheckbox } from '../../../../../Assets/Components/CCheckbox';

interface IProps {
  columnData: any[];
  countingParticipantManual: any;
  dataParticipantManual: any[];
  disabled: boolean;
  form: any;
  formValues: any;
  handleAddAgentManual: () => void;
  handleUpdateParticipant: () => void;
  isLoading: any;
  modalAction: string;
  selectedAgentManual: any[];
  channelCode: string;
}

export default function ParticipantComponent({
  columnData,
  countingParticipantManual,
  dataParticipantManual,
  disabled,
  formValues,
  handleAddAgentManual,
  handleUpdateParticipant,
  isLoading,
  modalAction,
  selectedAgentManual,
  channelCode,
}: IProps) {
  const {
    fromLengthType,
    participantLevel,
    participantType,
    toLengthType,
    totalAgentLOS,
  } = formValues;

  function AddTypeComponent() {
    const currentAgentValue =
      formValues.agentManual?.[countingParticipantManual]?.code;

    return (
      <div>
        <Field
          name={`agentManual.[${countingParticipantManual}].code`}
          component={Select}
          idComponent="searchAgents"
          dataOption={dataParticipantManual}
          label="Search Agents"
          placeholder="Search Agent Name"
          defaultItemName="Select"
          disabled={disabled}
          showSearch={true}
          optionFilterProp="label"
          filterOption={true}
        />
        <div className="btnAddData">
          <Button
            className="btnTransferText"
            icon={<CIcon type="PlusOutlined" />}
            disabled={disabled || currentAgentValue === undefined}
            id="btnAddSchedule"
            htmlType="button"
            onClick={handleAddAgentManual}
          >
            Add Data
          </Button>
        </div>
        <Table
          columns={columnData}
          pagination={true}
          data={selectedAgentManual || []}
          useFilterGlobal
          isLoading={isLoading}
        />
      </div>
    );
  }

  const optionLevels =
    channelCode === 'BA'
      ? baParticipantLevelNonSelf
      : channelCode === 'SA'
        ? saParticipantLevelNonSelf
        : classParticipantLevel;

  const convertAgent =
    channelCode === 'BA'
      ? convertAgentBALevelNonSelf
      : channelCode === 'SA'
        ? convertAgentSALevelNonSelf
        : convertAgentLevel;

  function LevelTypeComponent() {
    return (
      <div>
        <Field
          name="levelParticipantType"
          component={multipleCheckbox}
          optionsData={optionLevels}
          label="Select Level"
          disabled={modalAction === 'update'}
          className="divCheckbox"
          defaultItemName="Select"
        />
        {participantLevel && participantLevel.length > 0 && (
          <div className="totalAgent">
            Total Agent :{' '}
            {participantLevel?.map((v, i) => {
              return (
                <span key={i}>
                  {`${i !== 0 ? ', ' : ''}${convertAgent(v.level)} (${v.total
                    })`}
                  <div className="d-none">
                    <Field
                      name={`participantLevel.${i}.level`}
                      component="input"
                      disabled
                    />
                    <Field
                      name={`participantLevel.${i}.total`}
                      component="input"
                      type="number"
                      disabled
                    />
                  </div>
                </span>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  function LosTypeComponent() {
    return (
      <div>
        <b>Date Range (in months)</b>
        <div className="divParticipantLOSType">
          <b className="capital">From</b>
          <Field
            name="fromLengthType"
            component={InputTextNumber}
            idComponent="fromLengthType"
            disabled={modalAction === 'update'}
            min={0}
          />
          <b className="capital">To</b>
          <Field
            name="toLengthType"
            component={InputTextNumber}
            idComponent="toLengthType"
            disabled={modalAction === 'update'}
            min={0}
          />
        </div>
        {totalAgentLOS !== undefined &&
          !isNaN(totalAgentLOS) &&
          fromLengthType !== undefined &&
          !isNaN(fromLengthType) &&
          toLengthType !== undefined &&
          !isNaN(toLengthType) && (
            <>
              <p className="text-bolder">Total Agent : {totalAgentLOS}</p>
              <span className="d-none">
                <Field
                  name="totalAgentLOS"
                  component="input"
                  type="number"
                  disabled
                />
              </span>
            </>
          )}
      </div>
    );
  }

  return (
    <Row gutter={20}>
      <Col span={12}>
        <Field
          name="participantType"
          component={Select}
          idComponent="modalParticipantType"
          dataOption={classParticipantType}
          label="Type"
          placeholder="-Select-"
          defaultItemName="Select"
          disabled={modalAction === 'update'}
        />
      </Col>
      {modalAction === 'update' &&
        (participantType === 'LEVEL' || participantType === 'LOS') && (
          <Col span={12}>
            <Button
              type="primary"
              ghost
              icon={<CIcon type="ReloadOutlined" />}
              htmlType="button"
              onClick={handleUpdateParticipant}
              className="marginTop30"
            >
              Update Participant
            </Button>
          </Col>
        )}
      <Col span={24}>
        {participantType === 'LEVEL' ? (
          LevelTypeComponent()
        ) : participantType === 'LOS' ? (
          LosTypeComponent()
        ) : participantType === 'MANUAL' ? (
          AddTypeComponent()
        ) : (
          <></>
        )}
      </Col>
    </Row>
  );
}
